define("shared/utils/post/highlight-threads-topic", ["exports", "dompurify", "later/utils/constants"], function (_exports, _dompurify, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"dompurify",0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   * Highlights the threads topic in the text, escapes HTML characters
   * and returns the sanitized text
   * @param text The text to highlight the threads topic in
   * @returns The text with the threads topic highlighted
   */
  const highlightThreadsTopic = text => {
    const escapedText = _escapeHTML(text);
    const styledText = _applyTopicHighlights(escapedText);
    return _dompurify.default.sanitize(styledText);
  };

  /**
   * Applies the threads topic highlights to the text
   * @param text The text to apply the topic highlights to
   * @returns The text with the topic highlights applied
   */
  const _applyTopicHighlights = text => {
    return text.replace(_constants.VALID_THREADS_TOPIC, '<span class="u--text--hl">$&</span>');
  };

  /**
   * Escapes HTML tag characters in a string
   * @param str The string to escape
   * @returns The escaped string
   */
  const _escapeHTML = str => {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
  };
  var _default = _exports.default = highlightThreadsTopic;
});